import { render, staticRenderFns } from "./SupplierFormBankAccount.vue?vue&type=template&id=d87b260a&"
import script from "./SupplierFormBankAccount.vue?vue&type=script&lang=js&"
export * from "./SupplierFormBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports